module.exports = __webpack_public_path__ + "static/lumpia-ae3da351f83179ff2ae731897fa5fa7f.jpg";